/**
 * Gallery JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Export the class reference.
 */
export default class Gallery {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.$galleries = document.querySelectorAll('*[id^="imggallery"]');
    }

    /**
     * All common events
     */
    events() {
        $(this.$galleries).lightGallery({
            mode: 'lg-fade',
            download: 'false',
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/gallery.js